"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypoV2ClassesProvider = exports.CONTENT_BODY_POSTIT = exports.CONTENT_TITLE_POSTIT = exports.CONTENT_QUOTE = exports.CONTENT_BODY_BOLD_ITALIC = exports.CONTENT_BODY_ITALIC = exports.CONTENT_BODY_BOLD = exports.CONTENT_BODY_SM = exports.CONTENT_BODY = exports.CONTENT_H3 = exports.CONTENT_H2 = exports.CONTENT_H1 = exports.UI_STAT_SM = exports.UI_STAT_LG = exports.UI_HELPTEXT = exports.UI_TAG_DF = exports.UI_TAG = exports.UI_CAPTION_SEMIBOLD = exports.UI_CAPTION_SEMIBOLD_DF = exports.UI_CAPTION_BOLD_DF = exports.UI_CAPTION_DF = exports.UI_CAPTION_BOLD = exports.UI_CAPTION = exports.UI_PARAGRAPH_BOLD = exports.UI_PARAGRAPH = exports.UI_BODY_BOLD_SM_DF = exports.UI_BODY_BOLD_DF = exports.UI_BODY_SEMIBOLD_SM_DF = exports.UI_BODY_SEMIBOLD_DF = exports.UI_BODY_SM_DF = exports.UI_BODY_DF = exports.UI_BODY_BOLD_SM = exports.UI_BODY_BOLD = exports.UI_BODY_SEMIBOLD_SM = exports.UI_BODY_SEMIBOLD = exports.UI_BODY_SM = exports.UI_BODY = exports.UI_TITLE_SM = exports.UI_TITLE = exports.UI_HEADLINE_SM = exports.UI_HEADLINE = exports.UI_DISPLAY_SM = exports.UI_DISPLAY = void 0;
var react_1 = __importDefault(require("react"));
var index_styled_1 = require("./index.styled");
var utilsOolib_1 = require("../../../utilsOolib");
var fontSetting = {
    // these commented as new implementation has these styles as components (comp_bold, comp_medium, etc) 
    // originally it was prop controlled in v1 typo
    // bold: { type: 'fontWeight', value: 'bold' },
    // light: { type: 'fontWeight', value: '300' },
    // medium: { type: 'fontWeight', value: '500' },
    // semibold: { type: 'fontWeight', value: '600' },
    // extrabold: { type: 'fontWeight', value: '800' },
    // italic: { type: 'fontStyle', value: 'italic' },
    overline: { type: 'textDecoration', value: 'overline' },
    linethrough: { type: 'textDecoration', value: 'line-through' },
    underline: { type: 'textDecoration', value: 'underline' },
    capitalize: { type: 'textTransform', value: 'capitalize' },
    uppercase: { type: 'textTransform', value: 'uppercase' },
    lowercase: { type: 'textTransform', value: 'lowercase' },
};
var genFontStylingProps = function (props) {
    var _a;
    var newProps = {};
    for (var i in props) {
        var type = (_a = fontSetting[i]) === null || _a === void 0 ? void 0 : _a.type;
        if (!type) {
            continue;
        }
        var value = props[i] ? fontSetting[i].value : undefined;
        newProps[type] = value;
    }
    return newProps;
};
var GenComp = function (_a) {
    var props = _a.props, Comp = _a.Comp;
    var localize = (0, utilsOolib_1.useLocale)();
    var value = props.value, suffix = props.suffix, color = props.color, children = props.children, theme = props.theme, style = props.style, className = props.className, restProps = __rest(props, ["value", "suffix", "color", "children", "theme", "style", "className"]);
    var displayText = children || value;
    var localText = localize(displayText);
    return (react_1.default.createElement(Comp, __assign({}, genFontStylingProps(restProps), { color: color, className: className, style: style }),
        localText,
        " ",
        suffix || ''));
};
var UI_DISPLAY = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_DISPLAY_STYLED }); };
exports.UI_DISPLAY = UI_DISPLAY;
var UI_DISPLAY_SM = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_DISPLAY_SM_STYLED }); };
exports.UI_DISPLAY_SM = UI_DISPLAY_SM;
var UI_HEADLINE = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_HEADLINE_STYLED }); };
exports.UI_HEADLINE = UI_HEADLINE;
var UI_HEADLINE_SM = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_HEADLINE_SM_STYLED }); };
exports.UI_HEADLINE_SM = UI_HEADLINE_SM;
var UI_TITLE = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_TITLE_STYLED }); };
exports.UI_TITLE = UI_TITLE;
var UI_TITLE_SM = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_TITLE_SM_STYLED }); };
exports.UI_TITLE_SM = UI_TITLE_SM;
// UI BODY
var UI_BODY = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_STYLED }); };
exports.UI_BODY = UI_BODY;
var UI_BODY_SM = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_SM_STYLED }); };
exports.UI_BODY_SM = UI_BODY_SM;
var UI_BODY_SEMIBOLD = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_SEMIBOLD_STYLED }); };
exports.UI_BODY_SEMIBOLD = UI_BODY_SEMIBOLD;
var UI_BODY_SEMIBOLD_SM = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_SEMIBOLD_SM_STYLED }); };
exports.UI_BODY_SEMIBOLD_SM = UI_BODY_SEMIBOLD_SM;
var UI_BODY_BOLD = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_BOLD_STYLED }); };
exports.UI_BODY_BOLD = UI_BODY_BOLD;
var UI_BODY_BOLD_SM = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_BOLD_SM_STYLED }); };
exports.UI_BODY_BOLD_SM = UI_BODY_BOLD_SM;
// UI BODY DYNAMIC 
var UI_BODY_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_DF_STYLED }); };
exports.UI_BODY_DF = UI_BODY_DF;
var UI_BODY_SM_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_SM_DF_STYLED }); };
exports.UI_BODY_SM_DF = UI_BODY_SM_DF;
var UI_BODY_SEMIBOLD_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_SEMIBOLD_DF_STYLED }); };
exports.UI_BODY_SEMIBOLD_DF = UI_BODY_SEMIBOLD_DF;
var UI_BODY_SEMIBOLD_SM_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_SEMIBOLD_SM_DF_STYLED }); };
exports.UI_BODY_SEMIBOLD_SM_DF = UI_BODY_SEMIBOLD_SM_DF;
var UI_BODY_BOLD_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_BOLD_DF_STYLED }); };
exports.UI_BODY_BOLD_DF = UI_BODY_BOLD_DF;
var UI_BODY_BOLD_SM_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_BODY_BOLD_SM_DF_STYLED }); };
exports.UI_BODY_BOLD_SM_DF = UI_BODY_BOLD_SM_DF;
var UI_PARAGRAPH = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_PARAGRAPH_STYLED }); };
exports.UI_PARAGRAPH = UI_PARAGRAPH;
var UI_PARAGRAPH_BOLD = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_PARAGRAPH_BOLD_STYLED }); };
exports.UI_PARAGRAPH_BOLD = UI_PARAGRAPH_BOLD;
var UI_CAPTION = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_CAPTION_STYLED }); };
exports.UI_CAPTION = UI_CAPTION;
var UI_CAPTION_BOLD = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_CAPTION_BOLD_STYLED }); };
exports.UI_CAPTION_BOLD = UI_CAPTION_BOLD;
var UI_CAPTION_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_CAPTION_DF_STYLED }); };
exports.UI_CAPTION_DF = UI_CAPTION_DF;
var UI_CAPTION_BOLD_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_CAPTION_BOLD_DF_STYLED }); };
exports.UI_CAPTION_BOLD_DF = UI_CAPTION_BOLD_DF;
var UI_CAPTION_SEMIBOLD_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_CAPTION_SEMIBOLD_DF_STYLED }); };
exports.UI_CAPTION_SEMIBOLD_DF = UI_CAPTION_SEMIBOLD_DF;
var UI_CAPTION_SEMIBOLD = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_CAPTION_SEMIBOLD_STYLED }); };
exports.UI_CAPTION_SEMIBOLD = UI_CAPTION_SEMIBOLD;
var UI_TAG = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_TAG_STYLED }); };
exports.UI_TAG = UI_TAG;
var UI_TAG_DF = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_TAG_DF_STYLED }); };
exports.UI_TAG_DF = UI_TAG_DF;
var UI_HELPTEXT = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_HELPTEXT_STYLED }); };
exports.UI_HELPTEXT = UI_HELPTEXT;
var UI_STAT_LG = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_STAT_LG_STYLED }); };
exports.UI_STAT_LG = UI_STAT_LG;
var UI_STAT_SM = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.UI_STAT_SM_STYLED }); };
exports.UI_STAT_SM = UI_STAT_SM;
var CONTENT_H1 = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_H1_STYLED }); };
exports.CONTENT_H1 = CONTENT_H1;
var CONTENT_H2 = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_H2_STYLED }); };
exports.CONTENT_H2 = CONTENT_H2;
var CONTENT_H3 = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_H3_STYLED }); };
exports.CONTENT_H3 = CONTENT_H3;
var CONTENT_BODY = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_BODY_STYLED }); };
exports.CONTENT_BODY = CONTENT_BODY;
var CONTENT_BODY_SM = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_BODY_SM_STYLED }); };
exports.CONTENT_BODY_SM = CONTENT_BODY_SM;
var CONTENT_BODY_BOLD = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_BODY_BOLD_STYLED }); };
exports.CONTENT_BODY_BOLD = CONTENT_BODY_BOLD;
var CONTENT_BODY_ITALIC = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_BODY_ITALIC_STYLED }); };
exports.CONTENT_BODY_ITALIC = CONTENT_BODY_ITALIC;
var CONTENT_BODY_BOLD_ITALIC = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_BODY_BOLD_ITALIC_STYLED }); };
exports.CONTENT_BODY_BOLD_ITALIC = CONTENT_BODY_BOLD_ITALIC;
var CONTENT_QUOTE = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_QUOTE_STYLED }); };
exports.CONTENT_QUOTE = CONTENT_QUOTE;
var CONTENT_TITLE_POSTIT = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_TITLE_POSTIT_STYLED }); };
exports.CONTENT_TITLE_POSTIT = CONTENT_TITLE_POSTIT;
var CONTENT_BODY_POSTIT = function (props) { return react_1.default.createElement(GenComp, { props: props, Comp: index_styled_1.CONTENT_BODY_POSTIT_STYLED }); };
exports.CONTENT_BODY_POSTIT = CONTENT_BODY_POSTIT;
var TypoV2ClassesProvider = function (props) { return (react_1.default.createElement(index_styled_1.TYPO_V2_CLASSES, __assign({}, props))); };
exports.TypoV2ClassesProvider = TypoV2ClassesProvider;
